import React, { useState } from "react";
import PropTypes from "prop-types";
import InlineError from "../InlineError";
import "./style.scss";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const GlobalDropDown = (props) => {
  const {
    containerStyle,
    label,
    required,
    options,
    onChange,
    selectTagStyle,
    name,
    value,
    onBlur,
    hasInvalidSubmitOccurred,
    error,
    disabled,
    containerClass,
    defaultOptionText,
    defaultOptionDisable,
    option,
    type,
    ...rest
  } = props;
  
  const [touched, setTouched] = useState(false);

  const handleBlur = (e, name) => {
    setTouched(true);
    if (onBlur) {
      onBlur(e, name);
    }
  };
  const truncate = (str) =>
    str && str.length > 60 ? `${str.substring(0, 59)}...` : str;

  const displayError = touched || hasInvalidSubmitOccurred;

  // const handleChange = (event) => {
  //     setAge(event.target.value);
  //   };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          name={name}
          // MenuProps={{ disableScrollLock: true }} 
              // anchorOrigin={{vertical:"bottom"}}
              // MenuProps={{
              //   getContentAnchorEl: null,
              //   anchorOrigin: {
              //   vertical: "bottom",
              //   horizontal: "center",
              //   }
              //   }}
                anchorEl={this}
getContentAnchorEl={null}
anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
transformOrigin={{ vertical: "top", horizontal: "center" }}
          onChange={(e) => onChange(e, name)}
        >
          {option.map((option) => {
            return (
              //   {type ==="Country" || type==="State"?
              <MenuItem
                key={
                  type === "Country" || type === "State" ? option.isoCode : option.countryCode
                }
                label={option.name}
                value={ type === "Country" || type === "State" ? option.isoCode:option.name}
              >
                {option.name}
              </MenuItem>
              //     :<MenuItem value={option.isoCode}>
              //     {option.name}
              //   </MenuItem>
              //   }
              //   </div>
            );
          })}

          {/* <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem> */}
        </Select>
      </FormControl>
    </Box>
    // <div className={`global-select ${containerStyle} ${containerClass} ${displayError && error ? 'error' : ''}`}>
    //     {
    //         label &&
    //         <label
    //             htmlFor=""
    //         >
    //             {label}
    //             {
    //                 required
    //                 && (
    //                     <span className="required">&nbsp;*</span>
    //                 )
    //             }
    //         </label>}
    //     <select
    //         name={name}
    //         className={selectTagStyle}
    //         onChange={e => onChange(e, name)}
    //         onBlur={e => handleBlur(e, name)}
    //         value={value ? value : ''}
    //         disabled={disabled}
    //         {...rest}
    //     >
    //         {!defaultOptionDisable &&
    //             <option value=''>{defaultOptionText ? defaultOptionText : 'Select'}</option>
    //         }

    //         {
    //             options
    //             && options.length > 0
    //             && options.map((val, index) => {
    //                 return (
    //                     <option className="select-options" title={val.text} value={val.value} key={label + index}>{truncate(val.text)}</option>
    //                 )
    //             })
    //         }
    //     </select>
    //     {
    //         displayError && error && (
    //             <InlineError
    //                 message={error}
    //             />
    //         )
    //     }
    // </div>
  );
};

GlobalDropDown.propTypes = {
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  hasInvalidSubmitOccurred: PropTypes.bool,
  containerStyle: PropTypes.string,
  selectTagStyle: PropTypes.string,
  defaultOptionDisable: PropTypes.bool,
};

GlobalDropDown.defaultProps = {
  disabled: false,
  value: "",
  error: "",
  onChange: () => {},
  label: "",
  required: false,
  name: "",
  containerStyle: "",
  onBlur: () => {},
  hasInvalidSubmitOccurred: false,
  selectTagStyle: "",
  defaultOptionDisable: false,
};
export default GlobalDropDown;
